module.exports = __webpack_public_path__ + "static/work55-993d374a04c7342113b3caadbfb8f812.jpg";